import { PaintStyle } from "../../drawing/PaintStyle";

export interface IPaintable {
  paintStyle: PaintStyle;
}

export function instanceOfIPaintable(instance: any): instance is IPaintable {
  return instance
    && (instance.paintStyle !== undefined);
}
